var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small",
              on: { click: _vm.selectGoods }
            },
            [_vm._v("选择商品")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _vm.goodsRecvReturnItemList != null &&
        _vm.goodsRecvReturnItemList.length > 0
          ? _c("span", { staticClass: "ml10" }, [
              _vm._v(
                "已选择" +
                  _vm._s(_vm.optionFlag == "return" ? "退" : "换") +
                  "货商品数(" +
                  _vm._s(_vm.goodsRecvReturnItemList.length) +
                  ")"
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.goodsRecvReturnItemList,
            border: "",
            "tooltip-effect": "dark"
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "title",
              label: "商品名称",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "catName",
              label: "分类",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "brandName",
              label: "品牌",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "model",
              label: "型号",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "fixedSpec",
              label: "规格",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "tmpNo",
              label: "系统编号",
              width: "240",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "vendorUkno",
              label: "商品标识码",
              width: "200",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "right",
              prop: "quantity",
              label: "数量",
              width: "80",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "theUnit",
              label: "单位",
              width: "80",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "batchNo",
              label: "批次号",
              width: "140",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "80",
              label: "操作",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.removeGoods(scope.$index)
                          }
                        }
                      },
                      [_vm._v("移除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7de1786", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7de1786","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsRecvReturnItemList.vue
// module id = 2978
// module chunks = 0